/* Mobile behaviour: header collapse on scroll, menu drawer, announcement rotation,
   inline pharmacist tip in the collection grid, expandable medicine warning. Vanilla JS. */
(function () {
  var body = document.body;
  var mqPhone = window.matchMedia('(max-width: 767px)');
  var mqTablet = window.matchMedia('(max-width: 1080px)');
  var mqSmall = window.matchMedia('(max-width: 640px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header: the search field and the category bar sit under the logo row. After a scroll the search
     collapses into its icon; the category bar hides on scroll down and comes back on scroll up.
     Both are overlays, so the sticky header itself keeps the height of the logo row. */
  var hdr = document.querySelector('[data-header]');
  var mqDesk = window.matchMedia('(min-width: 768px)');
  var stickyWrap = hdr ? hdr.closest('.section-header-sticky') : null;

  /* Desktop: after 120 px of scroll the header condenses to one row (about 104 px with the category bar).
     The sticky wrapper keeps the full header height so the page does not jump when the header shrinks. */
  function measureHeader() {
    if (!hdr || !stickyWrap) return;
    var was = hdr.classList.contains('is-condensed');
    stickyWrap.style.minHeight = '';
    if (!mqDesk.matches) { hdr.classList.remove('is-condensed'); return; }
    hdr.classList.add('hdr-measure');
    hdr.classList.remove('is-condensed');
    stickyWrap.style.minHeight = hdr.offsetHeight + 'px';
    if (was) hdr.classList.add('is-condensed');
    void hdr.offsetHeight;
    hdr.classList.remove('hdr-measure');
  }
  function syncCondense(y) {
    if (!hdr || !mqDesk.matches) return;
    var on = hdr.classList.contains('is-condensed');
    if (!on && y > 120) hdr.classList.add('is-condensed');
    else if (on && y < 60) hdr.classList.remove('is-condensed');
  }
  if (hdr && stickyWrap) {
    measureHeader();
    window.addEventListener('load', measureHeader);
    window.addEventListener('resize', measureHeader);
    mqDesk.addEventListener('change', measureHeader);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureHeader);
  }
  if (hdr) {
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    var update = function () {
      ticking = false;
      var y = Math.max(0, window.pageYOffset || 0);
      var scrolled = y > 48;
      hdr.classList.toggle('is-scrolled', scrolled);
      syncCondense(y);
      if (!scrolled) {
        hdr.classList.remove('cats-up', 'search-open');
        syncSearchToggle();
      } else {
        var dy = y - lastY;
        if (dy < -8) {
          hdr.classList.add('cats-up');
        } else if (dy > 8) {
          hdr.classList.remove('cats-up');
          if (!hdr.contains(document.activeElement) || document.activeElement.tagName !== 'INPUT') {
            hdr.classList.remove('search-open');
            syncSearchToggle();
          }
        }
      }
      if (Math.abs(y - lastY) > 8) lastY = y;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function syncSearchToggle() {
    var t = document.querySelector('[data-search-toggle]');
    if (t && hdr) t.setAttribute('aria-expanded', hdr.classList.contains('search-open') ? 'true' : 'false');
  }

  /* Menu drawer */
  function openMenu() {
    body.classList.add('menu-open');
    var btn = document.querySelector('.menu-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var close = document.querySelector('[data-menu-drawer] [data-close-menu]');
    if (close) close.focus({ preventScroll: true });
  }
  function closeMenu() {
    if (!body.classList.contains('menu-open')) return;
    body.classList.remove('menu-open');
    var btn = document.querySelector('.menu-btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open-menu]');
    if (open) {
      if (!mqPhone.matches) return;
      e.preventDefault();
      openMenu();
      return;
    }
    if (e.target.closest('[data-close-menu]')) { closeMenu(); return; }
    var tog = e.target.closest('[data-search-toggle]');
    if (tog && hdr) {
      var on = !hdr.classList.contains('search-open');
      hdr.classList.toggle('search-open', on);
      syncSearchToggle();
      if (on) {
        var input = hdr.querySelector('#HeaderSearch');
        if (input) input.focus();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
  mqPhone.addEventListener('change', function () { if (!mqPhone.matches) closeMenu(); });

  /* Announcement bar: one message at a time under 768 px. */
  var msgs = document.querySelector('.announce .msgs');
  if (msgs && msgs.children.length > 1) {
    var items = Array.prototype.slice.call(msgs.children);
    var idx = 0;
    msgs.setAttribute('data-rot', '');
    items[0].classList.add('on');
    if (!reduce) {
      setInterval(function () {
        if (!mqPhone.matches || document.hidden) return;
        items[idx].classList.remove('on');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('on');
      }, 4500);
    }
  }

  /* Collection: the pharmacist tip card moves below the first 6 products on small screens. */
  function placeTip() {
    document.querySelectorAll('.c-tip-inline').forEach(function (n) { n.remove(); });
    if (!mqTablet.matches) return;
    var tip = document.querySelector('.c-hero .c-tip');
    var grid = document.querySelector('#ProductGridContainer .p-grid');
    if (!tip || !grid) return;
    var cards = grid.querySelectorAll('.p-card');
    if (!cards.length) return;
    var clone = tip.cloneNode(true);
    clone.classList.add('c-tip-inline');
    var after = cards[Math.min(6, cards.length) - 1];
    after.insertAdjacentElement('afterend', clone);
  }
  placeTip();
  document.addEventListener('grid:updated', placeTip);
  mqTablet.addEventListener('change', placeTip);

  /* Collection intro: "Plus" / "Moins" on phones. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-c-more]');
    if (!b) return;
    var box = b.closest('.c-title');
    var open = !box.classList.contains('open');
    box.classList.toggle('open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = b.getAttribute(open ? 'data-less' : 'data-more');
  });

  /* Medicine warning: expandable on phones, open on larger screens. */
  function syncWarn() {
    document.querySelectorAll('details.med-warn').forEach(function (d) { d.open = !mqSmall.matches; });
  }
  syncWarn();
  mqSmall.addEventListener('change', syncWarn);
})();
